export default "__VITE_ASSET__481fec7d__"